<template>
    <div>
            <div class="border rounded p-5 mb-3">
                <ParameterSelectbox code="housing_request_types" v-model="requestType" :public="true" />
            </div>
            <div class="col-12" v-if="requestType">
                <h6>
                    <span v-if="requestType && requestType.text">
                        {{ requestType.text }}
                    </span>
                </h6>
                <div class="border rounded p-5">
                    <component
                        v-if="type"
                        :is="type"
                        :data="reservationData"
                        :isManual="isManual"
                        @requestFormSuccess="$emit('requestFormSuccess')"
                    />
                </div>
            </div>

        <CommonModal  :size="constantCode==='housing_request.services_animal_request_text'?'lg':'md'" ref="warningModal" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
            <template v-slot:CommonModalTitle>
                <div>{{$t('warning')}}</div>
            </template>
            <template v-slot:CommonModalContent>
                <div>
                    <WarningModal v-if="formProgress==='Warning'" :constantCode="constantCode"  />
                </div>
            </template>
        </CommonModal>
    </div>
</template>

<script>
    // Pages
    import bedHoldRequest from './student/bedHoldRequest/Index'
    import serviceAnimal from './student/serviceAnimal/Index'
    import fobReplacement from './student/fobReplacement/Index'
    import roomKeyReplacement from './student/roomKeyReplacement/Index'
    import roomChangeRequest from './student/roomChangeRequest'
    import workOrderRequest from './student/workOrderRequest/Index'
    import initialComplaint from './student/initialComplaint/Index'
    import religiousExemption from './student/religiousExemption/Index'
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
    import WarningModal from "./WarningModal.vue"
    import airportTransferRequest from "./student/airportTransferRequest/Index.vue"
    import securityDepositRefundRequest from "./student/securityDepositRefundRequest/Index.vue"
    import beddingSetRequest from "./student/beddingSetRequest/Index"
    import {EventBus} from "@/main";

    export default {
        props:{
          reservationData:{
              type: Object,
          },
          isManual: {
              type: Boolean,
              default: false
          }
        },
        components: {
            WarningModal,
            bedHoldRequest,
            serviceAnimal,
            fobReplacement,
            roomKeyReplacement,
            roomChangeRequest,
            workOrderRequest,
            initialComplaint,
            ParameterSelectbox,
            religiousExemption,
            airportTransferRequest,
            securityDepositRefundRequest,
            beddingSetRequest
        },
        data() {
            return {
                formProgress:null,
                constantCode:null,
                requestType: null
            }
        },
        mounted() {
            EventBus.$on('bed_hold_request',(event)=>{
                this.constantCode=event.constant
                this.showWarningModal()
            })
            EventBus.$on('room_change_request',(event)=>{
                this.constantCode=event.constant
                this.showWarningModal()
            })
            EventBus.$on('services_animal',(event)=>{
                this.constantCode=event.constant
                this.showWarningModal()
            })
            EventBus.$on('formClearRequest',()=>{
                this.formClear()
            })
        },
        computed: {
            type(){
                if (this.requestType){
                    return  this.requestType?.replaceAll('_','-')
                }
                return this.requestType
            }

        },
        methods:{
            formClear(){
              this.formProgress=null
                this.$refs.warningModal.$refs.commonModal.hide()
            },
            showWarningModal(){
                this.formProgress='Warning'
                this.$refs.warningModal.$refs.commonModal.show()
            }
        }
    }
</script>
